import React from "react";

import { localizer } from "../../Translator";

import UserCli from "../../sdk/UserCli";

import { Grid, Container, Button, Paper } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { Typography } from "@material-ui/core";
import { SnackbarCustom } from "../Utilities/SnackbarCustom"

export class EmailAddressValidation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Email to be validated
      email: "",

      // Flag to determinate if email was validated successfully
      emailValidated: false,

      // Error message in case of validation fail
      severity: "info",
      message: null
    }
  }

  // Calling API for validate email taken parameters from URI
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token') !== null ? queryParams.get('token') : null
    const email = queryParams.get('email') !== null ? queryParams.get('email') : null
    const billable = queryParams.get('billable') !== null ? queryParams.get('billable') : null
    const user = queryParams.get('user') !== null ? queryParams.get('user') : null

    if (token && email && billable && user) {
      UserCli.ValidateEmail(email, user, billable, token).then(response => {
        if (response !== null && response.toString().startsWith("[ERR")) {
          this.setState({ message: response.substring(response.indexOf(' ')), severity: "error" })
        } else {
          this.setState({ email: email, emailValidated: true, message: localizer.EmailAddressValidateEmail, severity: "success" })
        }
      })
    } else {
      this.setState({ message: localizer.EmailAddressInvalidEmail, severity: "error" })
    }
  }
  handleonClose = () => {
    this.setState({ message: null })
   
  }
  render() {
    return (
      <React.Fragment>
        <Container maxWidth="md" spacing={4} className="mt-25 mb-75">
          <Grid container spacing={4} direction="row" justify="center" alignItems="stretch" className="mt-25">
            <Grid item xs={12} md={6} >
              <Paper elevation={2} >
                {this.state.emailValidated ?
                  <Grid container spacing={2} className="pl-18 pr-18 pb-12 pt-12">
                    <Grid item md={12}>
                      <Typography className="typography-generic"><strong>{this.state.email}</strong>{localizer.EmailAddressValidationEmailMessage}</Typography>
                    </Grid>
                    <Grid item md={12}>
                      <Button component={Link} to="/emailaddress" variant="contained" color="secondary" fullWidth>{localizer.EmailAddressRedirectTo}</Button>
                    </Grid>
                  </Grid>
                  :
                  <Grid container spacing={2} style={{ paddingLeft: 18, paddingRight: 18, paddingBottom: 12, paddingTop: 12 }}>
                    <Grid item md={12}>
                      <Typography className="typography-generic">{localizer.EmailAddressValidatingEmail}</Typography>
                    </Grid>
                  </Grid>
                }
              </Paper>
            </Grid>
          </Grid>
        </Container>
        {/*recover message. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
        
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/email-address/EmailAddressValidation.js